export default __webpack_public_path__ + "static/media/36I-102814_-16003_0.76fdd7be.jpg";